import { createContext, useContext } from 'react';
import { AppContextI } from '../types/user';

export const UserContext = createContext<AppContextI | undefined>(undefined);

export const useApp = (): AppContextI => {
  const context = useContext(UserContext);
  if (!context) {
    throw Error('useApp should be used within UserProvider.');
  }
  return context;
};
